import StorageService from "@/services/StorageService";
import Cookies from "js-cookie";

const TokenKey = "token";

export function isLogged() {
  return Cookies.get(TokenKey) || false;
}

export function setLogged(tokenValue, expires = 1) {
  return Cookies.set(TokenKey, tokenValue, { expires });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getUser() {
  return StorageService.read("user");
}
